<template>
    <v-layout row wrap justify-center>
        <!-- A button to return to the Menu's Item-->
        <v-flex xs12>
            <div class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack(menu.item_id)"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ menu.item_name }}
                </v-btn>
            </div>
        </v-flex>
        <ItemsListMenuLevels
                :levels="menu.levels"
                v-model="toComponent"></ItemsListMenuLevels>

        <!-- Displays a fixed area with the Sub-total of the Menu and with the Add button-->
        <v-card flat style="position:fixed; bottom:0; background-color:#fff">
            <v-card-actions>
                <v-btn
                        :disabled="!isEnabled"
                        @click="addToCart(menuIdentifier)"
                        class="primary"
                        large>
                    <v-icon left small>fal fa-shopping-cart</v-icon>
                    {{$vuetify.t('$vuetify.add') }}&nbsp;{{levelsSubTotal}}&nbsp;{{currencySymbol}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-layout>
</template>

<script>
    import {mapGetters} from "vuex";
    import {itemsService} from '@/_services/shop/items.service';
    import {getErrorMessage} from '@/_helpers';
    import ItemsListMenuLevels from '@/components/ItemsListMenuLevels.vue';

    export default {
        name: "CatalogItemDetailMenu",
        components: {ItemsListMenuLevels},
        data() {
            return {
                menu: {},
                menuIdentifier: null,
                /*https://vuejs.org/v2/guide/components.html#Using-v-model-on-Components*/
                toComponent: {
                    selectedLevelsIds: {},
                    panelShow: {},
                    disableLevel: {},
                    showDialog: {},
                    levelsItemsFlat: {},
                },

            }
        },
        methods: {
            /**
             * Adding the Menu to the Shopping Cart, which is stored on the local storage
             */
            addToCart: function () {
                let itemsIdMenu = [];
                let localLevelsItemsFlat = this.toComponent.levelsItemsFlat;

                //To add the Menu to the Shopping Cart it is necessary to know which Item was selected in each level
                //Iterating over the selected options
                for (let levelId in this.toComponent.selectedLevelsIds) {
                    if (localLevelsItemsFlat[levelId]) {
                        this.$log.debug("Detail Menu | Prepare To Cart | Level '" + localLevelsItemsFlat[levelId].description + "' (" + levelId + ")");
                    }

                    //Verifying if the selected option has a value. The checkboxes once "unselected" are included on the selectedLevelsIds but with the selected value = null.
                    // Example: 907_3601: null
                    if (this.toComponent.selectedLevelsIds[levelId] !== null) {
                        //The selected Item
                        let selectedLevelOptionId = this.toComponent.selectedLevelsIds[levelId];
                        //The definition of the selected Item: name, price, parent level (if exists)
                        let menuItem = localLevelsItemsFlat[selectedLevelOptionId];
                        //The Items of sub levels, should only be taken into account if the main level is selected
                        if (menuItem.parent_item && menuItem.parent_item_level) {
                            this.$log.debug("Detail Menu | Prepare To Cart | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") belongs to a Main Item " + menuItem.parent_item + " which belongs to level " + menuItem.parent_item_level);
                            if (!this.toComponent.selectedLevelsIds[menuItem.parent_item_level] || this.toComponent.selectedLevelsIds[menuItem.parent_item_level] !== menuItem.parent_item) {
                                this.$log.debug("Detail Menu | Prepare To Cart | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") belongs to a Main Item " + menuItem.parent_item + " which IS NOT selected");
                                continue;
                            }
                            this.$log.debug("Detail Menu | Calculate Total | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") belongs to a Main Item " + menuItem.parent_item + " which IS selected");

                        }
                        if (levelId.indexOf('_') > 0) {
                            itemsIdMenu.push(levelId);
                        } else {
                            itemsIdMenu.push(levelId + "_" + menuItem.item_id);
                        }
                    }
                }

                this.$store.dispatch("shop/addMenuToCart", {
                    'itemId': this.menu.item_id,
                    'itemsIdMenu': itemsIdMenu,
                });
                this.$router.push({name: "shop-item-detail", params: {id: this.menu.item_id}});
            },
            /**
             * The method assigned to the button which allows the user to return to the Menu's Item
             **/
            goBack(itemMenu) {
                this.$router.push({name: "shop-item-detail", params: {id: itemMenu}});
            },
        },
        computed: {
            ...mapGetters({
                currencySymbol: 'configs/currencySymbol'
            }),
            /**
             * Calculating the cost of the Menu, based on the Items chosen on each level
             *
             * @returns {}
             **/
            levelsSubTotal() {
                this.$log.debug("Detail Menu | Calculate Total");

                let sum = 0;
                let localLevelsItemsFlat = this.toComponent.levelsItemsFlat;

                //Iterating over the selected options
                for (let levelId in this.toComponent.selectedLevelsIds) {
                    if (localLevelsItemsFlat[levelId]) {
                        this.$log.debug("Detail Menu | Calculate Total | Level '" + localLevelsItemsFlat[levelId].description + "' (" + levelId + ")");
                    }
                    //Verifying if the selected option has a value. The checkboxes once "unselected" are included on the selectedLevelsIds but with the selected value = null.
                    // Example: 907_3601: null
                    if (this.toComponent.selectedLevelsIds[levelId] !== null) {
                        //The selected Item
                        let selectedLevelOptionId = this.toComponent.selectedLevelsIds[levelId];
                        //The definition of the selected Item: name, price, parent level (if exists)
                        let menuItem = localLevelsItemsFlat[selectedLevelOptionId];
                        //The Items of sub levels, should only be taken into account if the main level is selected
                        if (menuItem.parent_item && menuItem.parent_item_level) {
                            this.$log.debug("Detail Menu | Calculate Total | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") belongs to a Main Item " + menuItem.parent_item + " which belongs to level " + menuItem.parent_item_level);
                            if (!this.toComponent.selectedLevelsIds[menuItem.parent_item_level] || this.toComponent.selectedLevelsIds[menuItem.parent_item_level] !== menuItem.parent_item) {
                                this.$log.debug("Detail Menu | Calculate Total | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") belongs to a Main Item " + menuItem.parent_item + " which IS NOT selected");
                                continue;
                            }
                            this.$log.debug("Detail Menu | Calculate Total | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") belongs to a Main Item " + menuItem.parent_item + " which IS selected");

                        }
                        this.$log.debug("Detail Menu | Calculate Total | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") is selected");
                        if (menuItem.item_unit_price) {
                            this.$log.debug("Detail Menu | Calculate Total | Choice '" + menuItem.item_name + "' (" + selectedLevelOptionId + ") has a price definition " + menuItem.item_unit_price);
                            sum += parseFloat(menuItem.item_unit_price);
                        }
                    }
                    this.$log.debug("Detail Menu | Calculate Total | Sub Total: " + sum);
                }

                if (this.menu) {
                    this.$log.debug("Detail Menu | Calculate Total | Menu base price " + this.menu.price);
                    sum += parseFloat(this.menu.price);
                }

                this.$log.debug("Detail Menu | Calculate Total | Total: " + sum);
                return sum.toFixed(2);
            },
            /**
             * The function which validates if the Menu can be added to the Shopping Cart.
             * The condition to enable the button is:
             * each mandatory Level must have a selected Item
             *
             * @returns {boolean}
             */
            isEnabled() {
                this.$log.debug("Detail Menu | Evaluate the Add button can be Enabled");

                let auxLevelId = null;
                let distinctLevelsIds = [];

                for (let levelId in this.toComponent.selectedLevelsIds) {
                    if (this.toComponent.selectedLevelsIds[levelId] !== null) {
                        if (levelId.includes("_")) {
                            auxLevelId = levelId.split("_")[0];
                        } else {
                            auxLevelId = levelId;
                        }
                        if (!distinctLevelsIds.includes(auxLevelId)) {
                            this.$log.debug("Detail Menu | The Level was added to the list of selected levels");
                            distinctLevelsIds.push(parseInt(auxLevelId))
                        }
                    }
                }

                if (this.menu && this.menu.levels) {
                    this.$log.debug("Detail Menu | Iterating over all the levels of the menu");
                    for (let level of this.menu.levels) {
                        this.$log.debug("Detail Menu | Analysing level " + level.description + " (" + level.id + ") ");
                        if (level.mandatory === 1) {
                            this.$log.debug("Detail Menu | The level " + level.description + " (" + level.id + ")  is mandatory.");
                            if (!distinctLevelsIds.includes(level.id)) {
                                this.$log.debug("Detail Menu | The mandatory level " + level.description + " (" + level.id + ") was not selected");
                                return false
                            }
                        }
                        this.$log.debug("Detail Menu | Iterating over the Level's Items to evaluate if the Level has Items which are levels");

                        for (let item of level.items) {
                            if (this.toComponent.selectedLevelsIds[level.id] && this.toComponent.selectedLevelsIds[level.id] === item.item_id) {
                                if (item.levels && item.levels.length > 0) {
                                    this.$log.debug("Detail Menu | The Item selected " + item.item_name + "(" + item.item_id + ") has levels");
                                    for (let itemLevel of item.levels) {
                                        this.$log.debug("Detail Menu | Analysing Sublevel " + itemLevel.description + " (" + itemLevel.id + ")");
                                        if (itemLevel.mandatory === 1) {
                                            this.$log.debug("Detail Menu | The Sublevel " + itemLevel.description + " (" + itemLevel.id + ") is mandatory.");
                                            if (!distinctLevelsIds.includes(itemLevel.id)) {
                                                this.$log.debug("Detail Menu | The mandatory Sublevel " + itemLevel.description + " (" + itemLevel.id + ") was not selected");
                                                return false
                                            }
                                        }
                                    }
                                }
                            }
                        }

                    }
                }
                return true;
            },
        },
        mounted() {
            this.menuIdentifier = parseInt(this.$route.params.id);

            this.$store.dispatch("loader/setLoading", true);

            //Getting the Menu's data
            itemsService.getMenu(this.menuIdentifier).then(result => {
                    //Example of the Result Object
                    //     {"item_id": 3552,
                    //     "item_name": "Peru",
                    //     "price": "4.00",
                    //     "levels": {
                    //         "0": {
                    //             "id": "896",
                    //             "description": "Qual o tamanho da tua fome?",
                    //             "mandatory": 1,
                    //             "items": [{
                    //                     "item_id": 3369,
                    //                     "item_name": "Peru 15",
                    //                     "item_unit_price": "0.00"
                    //                 }, {
                    //                     "item_id": 3370,
                    //                     "item_name": "Peru 30",
                    //                     "item_unit_price": "0.00"
                    //                 }]},
                    //         "1": {
                    //             "id": "897",
                    //             "description": "Que tipo de pão preferes?",
                    //             "mandatory": 1,
                    //             "items": [{
                    //                     "item_id": 3555,
                    //                     "item_name": "Integral",
                    //                     "item_unit_price": "1.00"
                    //                 },
                    //                 ..... ]},
                    //         ......
                    //         } } }
                    this.menu = result;
                    this.$store.dispatch("loader/setLoading", false);

                    let flattenObject = function (levels, parent_item, parent_item_level) {
                        let toReturn = {};

                        for (let level of levels) {
                            toReturn[level.id] = level;
                            if (Array.isArray(level.items)) {
                                for (let item of level.items) {
                                    toReturn[item.item_id] = item;
                                    if (parent_item && parent_item_level) {
                                        toReturn[item.item_id].parent_item = parent_item;
                                        toReturn[item.item_id].parent_item_level = parent_item_level;
                                    }
                                    if (Array.isArray(item.levels)) {
                                        var flatObject = flattenObject(item.levels, item.item_id, level.id);
                                        for (var x in flatObject) {
                                            if (!flatObject.hasOwnProperty(x)) continue;
                                            toReturn[x] = flatObject[x];
                                        }
                                    }
                                }
                            }
                        }
                        return toReturn;
                    };
                    this.toComponent.levelsItemsFlat = flattenObject(this.menu.levels);

                    for (let menuLevel of this.menu.levels) {
                        //The Items of each level are displayed in an Expansion Panel
                        // In order to display all the Expansion Panel open, it is necessary to initialize, for each level
                        // the "status" of the Panel with the value 0
                        this.toComponent.panelShow[menuLevel.id] = 0;
                        this.toComponent.disableLevel[menuLevel.id] = 0;
                        this.toComponent.showDialog[menuLevel.id] = false;
                    }

                    //The change of the toolbar title has to be managed inside the promise where the Menu is obtained
                    // After setting the meta, it is necessary to force the router to reload,
                    // which is achieved by changing the query parameter
                    this.$route.meta.toolbarTitle = this.menu.item_name;
                    // Add a temporary query parameter.
                    this.$router.replace({query: {temp: Date.now()}});
                    // Remove the temporary query parameter.
                    this.$router.replace({query: {temp: undefined}});
                },
                error => {
                    getErrorMessage(error, 'Getting the Menu Detail', this);
                }
            );

        }
    }
</script>

<style scoped>

</style>